export default "__VITE_ASSET__Dc1B57wM__"